import Vue from 'vue'

const $eventHub = new Vue()

/**
 * Mixin
 */
export default {
    created()
    {
        this.$eventHub = $eventHub
    }
}



// WEBPACK FOOTER //
// ./src/mixins/EventHub.js